import ChangeSocialMediaLinks from './ChangeSocialMediaLinks';

export default ChangeSocialMediaLinks;